/**
 * Resuelve el intermediario de acuerdo-de-volumen (`es_acuerdo_volumen`, hoy OMNET) que aplica al
 * cliente, por holding (regla 10.7; hoy OMNET id 111 para el holding OMNICOM 120). El descuento del
 * modelo sale de SU `comision`/100 (ver 7.22). Fuente ÚNICA compartida por FlashEditModal
 * (preselección + badge del modal) y VentasFacturas (badge de la lista) para no duplicar/driftear.
 *
 * @param {number} clientId - id del cliente de la venta
 * @param {Array} clientes - array de clientes (con `agencia`)
 * @param {Array} intermediarios - array de intermediarios (con `holding_id`, `es_acuerdo_volumen`, `comision`)
 * @returns {Object|null} el intermediario de volumen, o null si no aplica
 */
export const resolverVolumenInter = (clientId, clientes, intermediarios) => {
  const cli = (clientes || []).find((c) => c.id === clientId);
  const agenciaId = cli?.agencia != null ? Number(cli.agencia) : null;
  const agInter = agenciaId != null ? (intermediarios || []).find((i) => i.id === agenciaId) : null;
  const holding = agInter ? (agInter.holding_id ?? agInter.id) : null;
  if (holding == null) return null;
  return (
    (intermediarios || []).find((i) => i.es_acuerdo_volumen && (i.holding_id === holding || i.id === holding)) || null
  );
};
